import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'left' | 'center';
  className?: string;
  light?: boolean;
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  className = '',
  light = false
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return <motion.div initial={{
    opacity: 0,
    y: 28
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={`${isCenter ? 'text-center mx-auto' : 'text-left'} max-w-2xl ${isCenter ? '' : ''} ${className}`} data-id="element-249">
      {eyebrow && <div className={`mb-4 flex items-center gap-3 ${isCenter ? 'justify-center' : ''}`} data-id="element-250">
          <span className="h-px w-8 bg-gold" data-id="element-251" />
          <span className="text-xs font-semibold uppercase tracking-[0.28em] text-gold-dark" data-id="element-252">
            {eyebrow}
          </span>
          {isCenter && <span className="h-px w-8 bg-gold" data-id="element-253" />}
        </div>}
      <h2 className={`font-display text-3xl font-bold leading-tight sm:text-4xl lg:text-[2.75rem] ${light ? 'text-white' : 'text-ink'}`} data-id="element-254">
        {title}
      </h2>
      {subtitle && <p className={`mt-5 text-base leading-relaxed sm:text-lg ${light ? 'text-white/70' : 'text-muted'}`} data-id="element-255">
          {subtitle}
        </p>}
    </motion.div>;
}